import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-primary-previous-button',
  templateUrl: './primary-previous-button.component.html',
  styleUrls: ['./primary-previous-button.component.less'],
})
export class PrimaryPreviousButtonComponent implements OnInit {
  @Output() onClick = new EventEmitter<any>();

  onClickButton(event) {
    this.onClick.emit(event);
  }

  constructor() {}

  ngOnInit(): void {}
}
